<template>
  <div class="userinfo_layout clearfix">
    <user-info-header class="header-wrap"
                      @onLoading="onLoading" />
    <div class="view-wrap layout-transition-fade">
      <router-view class="content-wrap" />
    </div>
    <transition name="loading">
      <div class="loading--wrap layout-transition-fade"
           v-show="loading">
        <ba-loading :applyBackground="true"
                    :showLoadingText="true"/>
      </div>
    </transition>
  </div>
</template>

<script>
import store from '@/store'
import { mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import UserInfoHeader from '@/components/user-info/Header'
import BaLoading from '@/components/ui/ba/Loading'

export default {
  name: 'DashboardLayout',
  components: {
    UserInfoHeader,
    BaLoading
  },
  created () {
    store.dispatch('storeScrollbarWidth')

    EventBus.$on('onLoading', (value) => {
      this.onLoading(value)
    })
    EventBus.$on('onError', (error, code = 500) => {
      this.setErrorData({ code, error })
    })
  },
  methods: {
    ...mapMutations([
      'setErrorData'
    ]),

    onLoading (value) {
      this.loading = value
    }
  },
  computed: {

  },
  data () {
    return {
      initialLoading: true,
      loading: true
    }
  }
}
</script>

<style lang="scss">
.userinfo_layout {
  width: 100%;
  min-width: 1400px;
  height: 100%;

  .header-wrap {
    transition: transform 0.3s ease,
    margin-bottom 0.3s ease;
  }

  .view-wrap {
    height: calc(100% - 47px);
    transition: height 0.3s ease;

    .content-wrap {
      position: relative;
      height: 100%;
      margin-left: 210px;
    }
  }

  .loading--wrap {
    position: fixed;
    top: 0;
    left: 210px;
    width: calc(100% - 210px);
    height: 100%;
    background: #F4F4F1;
    z-index: 20;
    transition: top 0.3s ease,
                height 0.3s ease;
    opacity: 1;

    .loading {
      @include positionXYcenter;
    }

    &.loading-enter-active,
    &.loading-leave-active {
      transition: opacity 0.3s ease,
                  height 0.3s ease !important;
    }

    &.loading-enter,
    &.loading-leave-to{
      opacity: 0;
    }
  }
}
</style>
